<template>
  <div class="relative flex min-h-screen w-screen overflow-hidden">
    <div
      class="animate flex-block absolute inset-y-0 z-10 w-full max-w-lg items-center justify-center overflow-y-auto bg-ontick-carbon-500 bg-opacity-90 py-2 px-6 backdrop-blur-sm backdrop-opacity-90 backdrop-filter duration-300 md:flex lg:px-20 xl:px-24"
      :class="
        selectedComponents == 'Register' || options_login || selectedComponents == 'RememberPassword'
          ? 'move-remember'
          : ''
      "
    >
      <div class="relative w-full overflow-hidden px-3 py-3">
        <div class="flex justify-center">
          <img v-if="partnerData" :src="partnerData.logo" />
          <span v-else v-html="$icons.logo_public"></span>
        </div>
        <div is="transition" v-on:enter="enter" v-on:leave="leave" v-bind:css="false" appear mode="out-in">
          <component
            @register="selectedComponents = 'Register'"
            @returnLogin="selectedComponents = 'Login'"
            @selectedRemember="selectedComponents = 'RememberPassword'"
            @termsOfUser="active_modal = true"
            :is="selectedComponents"
            :partnerName="partnerData && partnerData.name"
          ></component>
        </div>
      </div>
    </div>
    <div class="relative w-0 flex-1 lg:block">
      <img class="absolute inset-0 h-full w-full object-cover" src="@/app/assets/imagens/ontick_login_bg.jpg" alt="" />
    </div>
    <terms-of-user @close="active_modal = false" :active="active_modal" />
  </div>
</template>
<script>
import Login from "../components/login.component.vue";
import Register from "../components/register.component.vue";
import RememberPassword from "../components/remember.password.component.vue";
import TermsOfUser from "../components/terms-of-user.component.vue";
import bra from "@/app/assets/imagens/ontick-bra.svg";

export default {
  components: {
    Login,
    Register,
    RememberPassword,
    TermsOfUser,
  },
  data() {
    return {
      active: { register: false, login: true, remember_password: false },
      options_login: false,
      listComponents: ["Login", "Register", "RememberPassword"],
      selectedComponents: "Login",
      active_modal: false,
      partner: false,
      bra: bra,
    };
  },

  computed: {
    partnerData() {
      const partners = {
        bra: {
          logo: bra,
          name: "Seja BRA",
        },
        bs: {
          logo: "https://ontick-img.s3.sa-east-1.amazonaws.com/ontick_bs_signup-01.svg",
          name: "BS",
        },
        default: null,
      };
      return partners[this.$route.query.partner] || partners.default;
    },
  },

  methods: {
    enter(el, done) {
      TweenMax.fromTo(
        el,
        1,
        {
          autoAlpha: 0,
          scale: 1.5,
        },
        {
          autoAlpha: 1,
          scale: 1,
          transformOrigin: "50% 50%",
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },
    leave(el, done) {
      TweenMax.fromTo(
        el,
        1,
        {
          autoAlpha: 1,
          scale: 1,
        },
        {
          autoAlpha: 0,
          scale: 0.8,
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },
  },

  created() {
    switch (this.$route.query.mode) {
      case "create_password":
        this.selectedComponents = "RememberPassword";
        break;
      case "register":
        this.selectedComponents = "Register";
        break;
      default:
        this.selectedComponents = "Login";
    }
  },

  mounted() {
    if (this.$route.query.register) {
      this.selectedComponents = "Register";
    }

    if (this.$route.query.bra && this.$route.query.register) {
      this.partner = true;
    } else {
      this.partner = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.animate {
  left: 0;
}
.move {
  left: 100%;
  transform: translate(-100%, 0);
}
.move-remember {
  @apply left-0 -translate-x-0 md:left-[50%] md:-translate-x-2/4;
  // left: 50%;
  // transform: translate(-50%, 0);
}
.animate.right.move {
  right: 100%;
  transform: translate(100%, 0);
}
</style>
